import { render } from "./LegacyHome.vue?vue&type=template&id=0e32c5e2&scoped=true"
import script from "./LegacyHome.vue?vue&type=script&lang=js"
export * from "./LegacyHome.vue?vue&type=script&lang=js"

import "./LegacyHome.vue?vue&type=style&index=0&id=0e32c5e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e32c5e2"]])

export default __exports__